export default __webpack_public_path__ + "static/media/popup-icon-alert.e6cd8e92.svg";